import React, { Component } from 'react';
import { Jumbotron, Card, CardImg, CardBody, CardTitle, CardDeck, CardText, Button, Modal, Row, Col} from 'reactstrap';
import { Link } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import './App.css';
import Auth from './SignUp'



class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        }
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    componentDidMount() {

        var dbRef = firebase.database().ref("/user/" + firebase.auth().currentUser.uid);

        dbRef.on('value', (snapshot) => {
            let users = snapshot.val();
            this.setState({
                firstName: users.firstName,
                lastName: users.lastName,
                region: users.region,
                club: users.club,
                rating: users.rating,
                name: users.name,
                scoreHA: users.scoreHA,
                scoreHB: users.scoreHB,
                scoreC: users.scoreC,
                scoreD: users.scoreD,
                newUser: users.newUser
            })

        })

    }


    render() {

        return (
            <div>
                <Row>
                    <Col sm='12' md='6'>
                    <Intro userName={this.state.firstName} />
                    </Col>

                    <Col>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Button color="danger" onClick={this.toggle} style={{marginTop:'3em', marginBottom:'2em'}}> Sign up to Join the Game! </Button>
                    <Modal size='lg' isOpen={this.state.modal} toggle={this.toggle}>
                    <Auth user={this.props.user} />
                    </Modal>
                </div>
                    </Col>
                </Row>
                <Trivia />
                <ThankYou />
            </div>
        )
    }
}


class Intro extends Component {


    render() {

        return (
            <div style={{ paddingTop: '3em', paddingLeft: '2em' }}>
                <h1> Welcome to USPC Virtual Trivia! </h1>
                <p> We hope you accept the challenge, {this.props.userName} </p>
                <p> Compete on behalf of your club, region, and self. We challenge you to join the leaderboard! </p>
            </div>
        )
    }
}

class Trivia extends Component {

    render() {
        return (
            <div>
                <Jumbotron>
                    <CardDeck>
                        <Card className="trivia-card">
                            <Link to='/ha-trivia' style={{ color: 'black', textDecoration: 'none' }}>
                                <CardImg src='./img/ha.png' alt='HA Trivia' />
                                <CardBody>
                                    <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> H-A Trivia </CardTitle>
                                    <CardText> Take the H-A Challenge! </CardText>
                                </CardBody>
                            </Link>
                        </Card>

                        <Card className="trivia-card">
                        <Link to='/hb-trivia' style={{ color: 'black', textDecoration: 'none' }}>
                            <CardImg src='./img/hb.png' alt='HB Trivia' />
                            <CardBody>
                                <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> H-B Trivia </CardTitle>
                                <CardText> Take the H-B Challenge! </CardText>
                            </CardBody>
                            </Link>
                        </Card>

                        <Card className="trivia-card">
                        <Link to='/c-trivia' style={{ color: 'black', textDecoration: 'none' }}>
                            <CardImg src='./img/c.png' alt='C Trivia' />
                            <CardBody>
                                <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> C-Level Trivia </CardTitle>
                                <CardText> Take the C-Level Challenge! </CardText>
                            </CardBody>
                            </Link>
                        </Card>
                        <Card className="trivia-card">
                            <Link to='/d-trivia' style={{ color: 'black', textDecoration: 'none' }}>
                                <CardImg src='./img/d.png' alt='D Trivia' />
                                <CardBody>
                                    <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> D-Level Trivia </CardTitle>
                                    <CardText> Take the D-Level Challenge! </CardText>
                                </CardBody>
                            </Link>
                        </Card>
                    </CardDeck>
                </Jumbotron>
            </div>
        )
    }
}

class ThankYou extends Component {
    render() {
        return (
            <div>
                <p style={{ textAlign: 'center' }}> Brought to you by the United States Pony Clubs National Youth Board </p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Link to='/about'>
                        <img src='./img/nyb-logo.png' alt='NYB Logo' width='400px' height='100px' />
                    </Link>
                </div>
            </div>
        )
    }
}



export default Home;